import { useState } from "react"
import type { FormEvent } from "react"
import { PasswordInput } from "@alascorporation/ui"
import Label from "../form/Label"
import { getInputClasses } from "../form/input/InputField"
import Button from "../ui/button/Button"
import api from "../../lib/api"
import { getCurrentUser, getToken, persistAuthSession } from "../../lib/auth"
import { toastError } from "../../lib/toast"

// gestion-staff-my-account: lógica compartida por ChangePasswordPage.tsx (el
// gate forzado de contraseña temporal, ruta fija — ver ProtectedRoute.tsx) y
// el tab Seguridad de /account (cambio voluntario). Solo el formulario; cada
// caller decide su propio copy/layout y qué hacer al terminar.
export default function ChangePasswordForm({ onSuccess }: { onSuccess: () => void }) {
  const [currentPassword, setCurrentPassword] = useState("")
  const [newPassword, setNewPassword] = useState("")
  const [confirmPassword, setConfirmPassword] = useState("")
  const [loading, setLoading] = useState(false)

  async function onSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault()

    if (newPassword !== confirmPassword) {
      toastError("Las contraseñas nuevas no coinciden")
      return
    }
    if (newPassword.length < 8) {
      toastError("La nueva contraseña debe tener al menos 8 caracteres")
      return
    }

    setLoading(true)
    try {
      await api.put("/auth/password", { currentPassword, newPassword })

      const token = getToken()
      const user = getCurrentUser()
      if (token && user) {
        persistAuthSession(token, { ...user, mustChangePassword: false })
      }
      setCurrentPassword("")
      setNewPassword("")
      setConfirmPassword("")
      onSuccess()
    } catch (err) {
      toastError(err)
    } finally {
      setLoading(false)
    }
  }

  return (
    <form onSubmit={onSubmit} className="space-y-4">
      <div>
        <Label>Contraseña actual</Label>
        <PasswordInput
          value={currentPassword}
          onChange={(e) => setCurrentPassword(e.target.value)}
          required
          className={getInputClasses({})}
        />
      </div>
      <div>
        <Label>Nueva contraseña</Label>
        <PasswordInput
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          required
          className={getInputClasses({})}
        />
      </div>
      <div>
        <Label>Confirmar nueva contraseña</Label>
        <PasswordInput
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          required
          className={getInputClasses({})}
        />
      </div>

      <Button className="w-full" size="sm" disabled={loading}>
        {loading ? "Guardando..." : "Guardar contraseña"}
      </Button>
    </form>
  )
}
